module.exports = __webpack_public_path__ + "static/media/when-life-was-slow.0f7d19bb.png";